<template>
	<!-- Seller Profile -->
	<modal class="verification-modal" @close="close" :size='"medium"'>
		<template slot="header">
			<h3><b>{{ $t('Seller Profile') }}</b></h3>
		</template>
		<template slot="body">
			<div class="row" v-if="!isLoading">
				<div class="col-md-6">
					<overview
						:text="'Total Products'"
						:type="'normal'"
						:with-additional="false"
						:number="totalProducts">
					</overview>
				</div>
				<div class="col-md-6">
					<overview
						:text="'Total Orders'"
						:type="'normal'"
						:with-additional="false"
						:number="submissionCount">
					</overview>
				</div>
			</div>
			<div v-else class="is-loading mb-4"></div>
			<div v-if="user">
				<div class="row">
					<div class="col-md-6 mb-2">
						<div class="text-bold">Name</div>
						<div>{{ user.name }}</div>
					</div>
					<div class="col-md-6 mb-2">
						<div class="text-bold">Phone</div>
						<div>{{ userPhone }}</div>
					</div>
					<div class="col-md-6 mb-2">
						<div class="text-bold">Username</div>
						<div>{{ user.username }}</div>
					</div>
					<div class="col-md-6 mb-2">
						<div class="text-bold">Email</div>
						<div>{{ user.email }}</div>
					</div>
				</div>
				<hr />
				<div class="row">
					<div class="col-md-12 mb-2">
						<div class="text-bold">Business Address</div>
						<div>{{ userBusinessAddress }}</div>
					</div>
				</div>

				<div v-if="user.surveys && user.surveys.length > 0" class="row">
					<div class="col-md-12 mb-2">
						<div class="text-bold">
							Surveys
						</div>

						<div v-for="(survey, i) in user.surveys" :key="i">
							<div>
								<span>{{ survey.question }}</span>
							</div>
							<div class="">
								<span v-if="survey.key === 'Lainnya (Mohon jelaskan)'" class="text-capitalize">Answers : <b><template>{{survey.key}} | </template><i>{{ survey.value.replace('_', ' ') }}</i></b></span>
								<span v-else class="text-capitalize">Answers : <b>{{ survey.value.replace('_', ' ') }}</b></span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="text-center">Data Seller Tidak Ditemukan</div>
		</template>
		<template slot="footer">
			<button class="btn btn-light" @click="close">
				{{ $t('Close') }}
			</button>
			<button class="btn btn-primary" @click="openVerificationModal" v-if="this.sourcePage === 'default'">
				{{ $t('Identity') }}
			</button>
		</template>
	</modal>
</template>

<script>
import userApi from '@/api/user';
import Modal from '@/components/Modal.vue';
import Overview from '@/components/Overview.vue';
import {
	getAxiosErrorMessage,
	validatePhoneNumber,
} from '@/lib/helper';

export default {
	name: 'ModalSellerProfile',
	components: {
		Modal,
		Overview,
	},
	props: {
		user: {
			type: Object,
			default: null,
		},
		source: {
			type: String,
			default: 'default',
		},
	},
	data() {
		return {
			isLoading: false,
			stats: null,
			totalProducts: 0,
		};
	},
	methods: {
		close() {
			this.$emit('close');
		},
		openVerificationModal() {
			this.$emit('verification', this.user);
		},
		getUserStats(userId) {
			this.isLoading = true;
			const params = {
				user_id: userId,
				all_products: true,
				include_stats: true,
			};

			const callback = (response) => {
				const userDetail = response.data;
				this.stats = userDetail?.statistics;
				this.totalProducts = userDetail?.total_products;
				this.isLoading = false;
			};

			const errorCallback = (e) => {
				this.isLoading = false;
				const message = getAxiosErrorMessage(e);
				console.log('message: ', message);
			};

			userApi.getUserStats(params, callback, errorCallback);
		},
	},
	mounted() {
		if (this.user && this.user._id) {
			this.getUserStats(this.user._id);
		}
	},
	computed: {
		submissionCount() {
			return this.stats?.submission_count || 0;
		},
		userPhone() {
			let phone = '';
			if (this.user && this.user.phone) {
				const validatedPhone = validatePhoneNumber(this.user.phone);
				phone = `+62${validatedPhone}`;
			}
			return phone;
		},
		userBusinessAddress() {
			const store = this.user?.store;
			const address = store?.address;

			const origin = store?.shipping?.origin;
			const subdistrict = origin?.subdistrict?.name;
			const city = origin?.city?.name;
			const province = origin?.province?.name;
			const zip = origin?.zip;

			let businessAddress = '';
			if (address && subdistrict && city && province && zip) {
				businessAddress = `${address}, ${subdistrict}, ${city}, ${province}, ${zip}`;
			}
			return businessAddress || '-';
		},
		sourcePage() {
			return this.source;
		},
	},
};
</script>
